/*
 * Yulan v3 « Jardin aux lanternes »
 * - bascule clair / sombre (bouton d'en-tête, mémorisée dans localStorage)
 * - accueil : ciel aube → crépuscule au défilement, disque soleil → lune,
 *   branche qui se dessine, fleurs qui s'ouvrent, lueur des lanternes,
 *   étoiles, pétales qui tombent, teinte de la rangée Évoli
 *
 * v3i (2026-09-16, performance) : plus de recoloration en JS ni de variables sur <html>.
 * Le défilement ne pose que --yv3-t / --yv3-glow / --yv3-starop / --yv3-grow / --yv3-st sur le ciel et le haut
 * de page (les calques de nuit, de lune et de lueur sont des opacités, voir assets/yulan-v3i.css), au plus une fois
 * par image, par pas de 1 %, sans lecture de style ni de géométrie (hauteur mesurée une fois, puis au redimensionnement).
 * Les pétales sont dessinés à 30 images/s et la couleur est mise en cache.
 * v3t : pétales aussi denses sur ordinateur que sur mobile ; courte chute à l'arrivée en « mouvement réduit ».
 * v3z (2026-10-09) : à la demande de la boutique, le décor de l'accueil est le même sur ordinateur que sur téléphone,
 * y compris avec « mouvement réduit » (pétales un peu plus lents), et les pétales continuent de tomber quand on
 * descend la page (ils restaient limités au haut de page). Toujours en pause quand l'onglet est caché.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cacheBlossom = null;

  /* ---------- Thème clair / sombre ---------- */
  function currentTheme() {
    var a = root.getAttribute('data-theme');
    if (a === 'dark' || a === 'light') return a;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function updateToggles() {
    var dark = currentTheme() === 'dark';
    var buttons = document.querySelectorAll('[data-yulan-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', dark ? 'true' : 'false');
      buttons[i].setAttribute('aria-label', dark ? 'Passer en mode clair' : 'Passer en mode sombre');
      buttons[i].setAttribute('title', dark ? 'Mode clair' : 'Mode sombre');
    }
  }

  function updateMeta() {
    var m = document.querySelector('meta[name="theme-color"]');
    if (m) m.setAttribute('content', getComputedStyle(document.body).backgroundColor);
  }

  function applyTheme(v) {
    if (v === 'dark' || v === 'light') root.setAttribute('data-theme', v);
    else root.removeAttribute('data-theme');
    updateToggles();
    updateMeta();
    if (cacheBlossom) cacheBlossom();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-yulan-theme-toggle]');
    if (!b) return;
    var next = currentTheme() === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem('yulan-theme', next); } catch (err) {}
    applyTheme(next);
  });

  try {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function () {
      updateToggles();
      updateMeta();
      if (cacheBlossom) cacheBlossom();
    });
  } catch (e) {}

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ---------- Ciel, disque, branche, lueur (accueil) ---------- */
  var hero = document.querySelector('[data-yv3-hero]');
  var sky = document.querySelector('[data-yv3-sky]');
  var branch = document.querySelector('[data-yv3-branch]');
  var paths = [];
  if (branch) {
    var list = branch.querySelectorAll('path');
    for (var p = 0; p < list.length; p++) {
      var len = list[p].getTotalLength();
      list[p].style.strokeDasharray = len;
      paths.push({ el: list[p], len: len });
    }
  }

  var heroH = 0, heroTop = 0, lastT = -1, lastSt = -1, ticking = false;

  function measure() {
    if (!hero) return;
    heroH = hero.offsetHeight;
    heroTop = hero.offsetTop;
  }

  function setVars(el, t, st) {
    if (!el) return;
    var s = el.style;
    s.setProperty('--yv3-t', t);
    s.setProperty('--yv3-glow', t);
    s.setProperty('--yv3-starop', clamp((t - 0.3) / 0.7, 0, 1).toFixed(2));
    s.setProperty('--yv3-grow', (0.35 + 0.65 * t).toFixed(2));
    s.setProperty('--yv3-st', st);
  }

  function update() {
    ticking = false;
    if (!hero) return;
    var span = Math.max(320, heroH * 0.85);
    var y = window.scrollY || 0;
    var t = Math.round(clamp(y / span, 0, 1) * 100) / 100;
    var st = Math.round(Math.min(y, span * 2) / 4) * 4;
    if (t === lastT && st === lastSt) return;
    lastT = t;
    lastSt = st;
    setVars(hero, t, st);
    setVars(sky, t, st);
    var d = 1 - (0.4 + 0.6 * t);
    for (var i = 0; i < paths.length; i++) {
      paths[i].el.style.strokeDashoffset = (paths[i].len * d).toFixed(0);
    }
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    if (window.requestAnimationFrame) requestAnimationFrame(update);
    else setTimeout(update, 16);
  }

  if (hero) {
    measure();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () { measure(); schedule(); });
    window.addEventListener('load', function () { measure(); lastT = -1; schedule(); });
    update();
  }

  /* ---------- Pétales (30 images/s, couleur en cache, arrêt hors du haut de page) ----------
   * v3t (2026-10-01) : même densité ressentie sur ordinateur que sur mobile (26 pétales dès 1 280 px, 18 entre
   * 750 et 1 279 px, 8 sur mobile ; pétales 25 % plus grands dès 990 px), calque net sur les écrans haute
   * densité. Avec « mouvement réduit » (par exemple « Effets d'animation » désactivé dans Windows), au lieu de
   * ne rien afficher : une courte chute à l'arrivée, environ 5 secondes, puis fondu et arrêt. */
  var cv = document.querySelector('[data-yv3-petals]');
  if (cv && hero && window.requestAnimationFrame) {
    var ctx = cv.getContext('2d');
    var W = 0, H = 0, P = [], running = !document.hidden, blossom = '#F0BFC0', last = 0;
    var brief = false, briefStart = 0, BRIEF = 4500, FADE = 1000, done = false, slow = reduce ? 0.7 : 1;

    cacheBlossom = function () {
      blossom = getComputedStyle(root).getPropertyValue('--yv3-blossom').trim() || '#F0BFC0';
    };

    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = window.innerWidth;
      H = window.innerHeight;
      cv.width = Math.round(W * dpr);
      cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    window.addEventListener('resize', size);

    var n = W < 750 ? 8 : W < 1280 ? 18 : 26;
    var big = W >= 990 ? 1.25 : 1;
    for (var k = 0; k < n; k++) {
      P.push({
        x: Math.random() * W,
        y: brief ? Math.random() * H * 1.1 - H * 0.35 : Math.random() * H * 1.3,
        r: (5 + Math.random() * 5) * big,
        vx: 0.2 + Math.random() * 0.4,
        vy: 0.5 + Math.random() * 0.7,
        a: Math.random() * 6.28,
        va: 0.01 + Math.random() * 0.02
      });
    }

    function draw(f, alpha) {
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = blossom;
      ctx.globalAlpha = 0.9 * alpha;
      for (var i = 0; i < P.length; i++) {
        var q = P[i];
        q.x += (q.vx + Math.sin(q.a) * 0.4) * f;
        q.y += q.vy * f;
        q.a += q.va * f;
        if (q.y > H + 20) { q.y = -20; q.x = Math.random() * W; }
        if (q.x > W + 20) q.x = -20;
        ctx.save();
        ctx.translate(q.x, q.y);
        ctx.rotate(q.a);
        ctx.beginPath();
        ctx.ellipse(0, 0, q.r, q.r * 0.6, 0, 0, 6.283);
        ctx.fill();
        ctx.restore();
      }
    }

    function tick(now) {
      if (!running || done) return;
      var alpha = 1;
      if (brief) {
        if (!briefStart) briefStart = now;
        var el = now - briefStart;
        if (el > BRIEF + FADE || (window.scrollY || 0) > heroTop + heroH + 200) {
          ctx.clearRect(0, 0, W, H);
          done = true;
          return;
        }
        if (el > BRIEF) alpha = 1 - (el - BRIEF) / FADE;
      }
      if (now - last >= 32) {
        var f = (last ? clamp((now - last) / 16.7, 1, 4) : 2) * slow;
        last = now;
        draw(f, alpha);
      }
      requestAnimationFrame(tick);
    }

    document.addEventListener('visibilitychange', function () {
      var was = running;
      running = !document.hidden;
      if (running && !was && !done) { last = 0; requestAnimationFrame(tick); }
    });
    cacheBlossom();
    requestAnimationFrame(tick);
  }

  /* ---------- Rangée Évoli : teinte au survol ---------- */
  var buds = document.querySelectorAll('[data-yv3-tint]');
  for (var b = 0; b < buds.length; b++) {
    buds[b].addEventListener('mouseenter', function () {
      var sec = this.closest('[data-yv3-evo]');
      if (sec) sec.style.setProperty('--tint', this.getAttribute('data-yv3-tint'));
    });
    buds[b].addEventListener('focusin', function () {
      var sec = this.closest('[data-yv3-evo]');
      if (sec) sec.style.setProperty('--tint', this.getAttribute('data-yv3-tint'));
    });
  }

  /* ---------- Bouton clair / sombre dans l'en-tête (avant le panier) ---------- */
  (function injectToggle() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('[data-yulan-theme-toggle]')) return;
    var SUN = '<svg class="yv3-icon yv3-icon--sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2.6M12 18.9v2.6M2.5 12h2.6M18.9 12h2.6M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8"/></svg>';
    var MOON = '<svg class="yv3-icon yv3-icon--moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z"/></svg>';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'header__icon header__icon--theme yulan-theme-toggle link focus-inset';
    b.setAttribute('data-yulan-theme-toggle', '');
    b.innerHTML = '<span class="svg-wrapper yulan-theme-toggle__sun">' + SUN + '</span><span class="svg-wrapper yulan-theme-toggle__moon">' + MOON + '</span>';
    var cart = icons.querySelector('#cart-icon-bubble');
    if (cart) icons.insertBefore(b, cart); else icons.appendChild(b);
  })();

  updateToggles();
  updateMeta();
})();
